<div class="container">
    <div class="top-section">
        <div class="heading-container">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        </div>
        <span class="reward-heading">{{ "reward.heading.coupons&Rewards" | translate }}</span>
        <img class="rewards-icon" src="../../assets/coin-img.png" />
    </div>

    <div class="bottom-section" *ngIf="rewards?.length; else noRewardTemplate">
        <div class="botton-coin-blc-section">
            <span class="coin-blc-heading">{{ "reward.heading.coinBalance" | translate }}</span>
            <span class="coin-number-container">
                <img class="rewards-icon" src="../../assets/coin-img.png" />
                <span>{{ totalBalance }}</span>
            </span>
        </div>

        <div class="bottom-transaction-section">
            <div class="transaction-top">
                <span class="transaction-details-label">{{ "reward.heading.transationDetails" | translate }}</span>
                <span class="transaction-details-label">{{ "reward.heading.coinsDetails" | translate }}</span>
            </div>

            <div class="transaction-bottom">
                <div *ngFor="let reward of rewards" class="reward-card">
                    <div class="transaction-details-left-section">
                        <div class="structure-name">
                            {{ getDisplayName(reward) }}
                        </div>

                        <div class="date">
                            {{ reward.type === RewardType.Debited ? RewardType.Debited : RewardType.Credited }} on
                            {{ reward.createdAt | date: "yyyy-MM-dd HH:mm:ss" }}
                        </div>
                    </div>
                    <div class="transaction-details-right-section">
                        <span
                            [ngClass]="{
                                positive: reward.type === RewardType.Credited,
                                negative: reward.type === RewardType.Debited
                            }"
                        >
                            {{ reward.amount }}
                        </span>
                    </div>
                </div>
                <button class="save-btn view" *ngIf="showViewMoreButton()" mat-flat-button (click)="loadMoreRewards()">
                    {{ "reward.button.viewMoreBtn" | translate }}
                </button>
            </div>
        </div>
    </div>

    <ng-template #noRewardTemplate>
        <div class="no-rewards" *ngIf="!loading">
            <mat-icon svgIcon="noReward" class="no-reward-icon" aria-hidden="false" aria-label="rewards"></mat-icon>
            <h2>{{ "reward.heading.noReward" | translate }}</h2>
            <p>{{ "reward.heading.noRewardMessage" | translate }}</p>
            <button mat-flat-button class="save-btn" (click)="goToHomePage()">
                {{ "reward.button.backToHomeBtn" | translate }}
            </button>
        </div>
    </ng-template>
</div>
